import { ReactNode } from "react";

import { useSelectModeData } from "../data/use_select_mode_data";
import { useSmartPlannerData } from "../data/use_smart_planner_data";
import { useSplitModeData } from "../data/use_split_mode_data";
import { useWallPlannerData } from "../data/use_wall_planner_data";

export interface BookingEditModeDataControllerProps {
  children: ReactNode;
}

export const BookingEditModeDataController = ({ children }: BookingEditModeDataControllerProps) => {
  useSelectModeData();
  useSmartPlannerData();
  useSplitModeData();
  useWallPlannerData();

  return <>{children}</>;
};
